import { AUTH0_INJECTION_KEY } from '@auth0/auth0-vue';
import { hasInjectionContext, inject } from 'vue';

import { getRegisteredAuth0Client } from '../../auth0-client-access';
import type { Auth0ClientLike } from '../session/types';

export const resolveAuth0Client = (
  auth0Client?: Auth0ClientLike | null,
): Auth0ClientLike | null => {
  if (auth0Client) {
    return auth0Client;
  }

  const registeredClient = getRegisteredAuth0Client();

  if (registeredClient) {
    return registeredClient;
  }

  if (hasInjectionContext()) {
    return inject<Auth0ClientLike | null>(AUTH0_INJECTION_KEY, null);
  }

  return null;
};
